export enum Assignee {
  Me = 'me',
  Free = 'free',
  All = 'all',
}
